import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, AlertTriangleIcon } from 'lucide-react';
export function PainSection() {
  return <section className="bg-zinc-950 py-16 sm:py-24" data-id="element-216">
      <div className="max-w-4xl mx-auto px-4" data-id="element-217">
        {/* Opening hook */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-218">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-6" data-id="element-219">
            <span className="text-red-500" data-id="element-220">¿Cuántos tutoriales buscaste</span>{' '}
            antes de llegar aquí?
          </h2>
          <p className="text-xl text-zinc-400" data-id="element-221">
            Uno. Cinco. Diez.{' '}
            <span className="text-white font-semibold" data-id="element-222">
              Y siempre lo mismo.
            </span>
          </p>
        </motion.div>

        {/* Pain points */}
        <div className="space-y-6 mb-12" data-id="element-223">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-red-500/5 border border-red-500/20 rounded-xl p-6" data-id="element-224">
            <div className="flex items-start gap-4" data-id="element-225">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-226" />
              <div data-id="element-227">
                <p className="text-white font-semibold mb-2" data-id="element-228">
                  El video está desactualizado
                </p>
                <p className="text-zinc-400" data-id="element-229">
                  El link del APK ya no existe. Instalaste algo y no pasó nada.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-red-500/5 border border-red-500/20 rounded-xl p-6" data-id="element-230">
            <div className="flex items-start gap-4" data-id="element-231">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-232" />
              <div data-id="element-233">
                <p className="text-white font-semibold mb-2" data-id="element-234">
                  Instalaste algo y tu celular empezó a actuar raro
                </p>
                <p className="text-zinc-400" data-id="element-235">
                  Descargaste de un sitio dudoso y ahora tienes miedo de haberlo
                  arruinado.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-red-500/5 border border-red-500/20 rounded-xl p-6" data-id="element-236">
            <div className="flex items-start gap-4" data-id="element-237">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-238" />
              <div data-id="element-239">
                <p className="text-white font-semibold mb-2" data-id="element-240">
                  Sigues pagando Netflix, Disney+, Star+...
                </p>
                <p className="text-zinc-400" data-id="element-241">
                  Todos los meses, sin falta — para ver el 10% del catálogo que
                  realmente te interesa.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Emotional amplification */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-r from-amber-500/10 to-red-500/10 border border-amber-500/20 rounded-2xl p-8 text-center" data-id="element-242">
          <AlertTriangleIcon className="w-12 h-12 text-amber-500 mx-auto mb-4" data-id="element-243" />
          <p className="text-lg sm:text-xl text-white font-medium leading-relaxed" data-id="element-244">
            Esa sensación de frustración técnica — la de sentirte torpe frente a
            algo que <span className="text-amber-400" data-id="element-245">"todos hacen fácil"</span>{' '}
            — es exactamente lo que esta guía elimina.
          </p>
        </motion.div>

        {/* Bridge statement */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-center text-zinc-400 text-lg mt-10" data-id="element-246">
          Lo entendemos. Y precisamente por eso existe esta guía.
        </motion.p>
      </div>
    </section>;
}